import AttachFileIcon from '@mui/icons-material/AttachFile'
import DeleteIcon from '@mui/icons-material/Delete'
import SaveAltIcon from '@mui/icons-material/SaveAlt'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useSnackbar } from 'notistack'
import { useContext, useEffect, useRef, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { ExpedientesContext } from '../../providers/ExpedientesProvider'
import LabelComponent from '../LabelComponent'

const FileComponent = (props) => {
  const {
    active: { current: tipo_expediente },
    campos_expediente,
    setCampoError,
    subirFichero,
    uploadingFile,
    ficherosSubidos,
    idProceso,
    eliminarFichero,
  } = useContext(ExpedientesContext)

  const divRef = useRef(null)

  const { enqueueSnackbar } = useSnackbar()

  const [selectedType, setSelectedType] = useState('')
  const [files, setFiles] = useState([])

  useEffect(() => {
    if (ficherosSubidos && ficherosSubidos.length > 0) {
      divRef?.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [ficherosSubidos])

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value)
  }

  const handleDeleteFile = async (id_documento) => {
    await eliminarFichero(idProceso, id_documento)
  }

  const onDrop = (acceptedFiles) => {
    if (!selectedType) {
      enqueueSnackbar('Selecciona un tipo de documento antes de subir archivos.', {
        variant: 'warning',
      })
      return false
    }

    const newFiles = acceptedFiles.map((file) => ({
      file,
      tipo_documento: selectedType,
      tipo_expediente: tipo_expediente.tipo_expediente,
      uploaded: false,
    }))

    const updatedFiles = [...files, ...newFiles]
    setFiles(updatedFiles)

    // Subir cada archivo automáticamente
    newFiles.forEach((f, idx) => {
      subirFichero(f.file, f.tipo_documento, f.tipo_expediente)
      setSelectedType('')
    })
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
  })

  const campos = campos_expediente
  const campo = campos.filter((c) => c.columna === props.columna)[0]

  if (campo && campo.oculto !== 'S') {
    return (
      <Stack spacing={2} sx={{ width: campo.ancho ? campo.ancho + '%' : '100%' }}>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={uploadingFile}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <LabelComponent text={`${campo.literal} ${campo.obligatorio === 'S' ? '*' : ''}`} />
        {/* Selector de tipo de documento */}
        {props?.documentTypes && (
          <FormControl sx={{ width: '100%' }}>
            <InputLabel width="100%" required={campo.obligatorio === 'S'}>
              Tipo de Documento
            </InputLabel>
            <Select label="Tipo de Documento" value={selectedType} onChange={handleTypeChange}>
              {props?.documentTypes?.map((doc) => (
                <MenuItem key={doc.tipo} value={doc.tipo}>
                  {doc.d_tipo}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <Box
          component="span"
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            border: '2px dashed',
            borderColor:
              campo.error && ficherosSubidos.length === 0 ? 'error.main' : 'primary.main',
            backgroundColor: 'background.default',
          }}
        >
          <div {...getRootProps({ className: 'dropzone' })}>
            <input {...getInputProps()} />

            <SaveAltIcon />
            <p>Arrastre aquí ficheros o haga click para seleccionar</p>
            <aside>
              <h4>Ficheros</h4>
              {/* <ul>{files}</ul> */}
            </aside>
          </div>
        </Box>
        {ficherosSubidos && ficherosSubidos.length > 0 && (
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
              Ficheros cargados
            </Typography>
            <List ref={divRef}>
              {ficherosSubidos.map((fichero, index) => {
                return (
                  <ListItem
                    key={fichero.id_documento || index}
                    secondaryAction={
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => handleDeleteFile(fichero.id_documento)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    }
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <AttachFileIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={fichero.nombre_fichero}
                      secondary={fichero.tipo_documento}
                    />
                  </ListItem>
                )
              })}
            </List>
          </Grid>
        )}
      </Stack>
    )
  }
}

export default FileComponent
